import cn from 'classnames';
import { ReactComponent as SvgSnowFlake } from 'public/assets/icons/snowflake.svg';
import { SnowUnit } from 'components/blocks/Unit';
import { formatAsTodYestTomWeekday } from 'util/formatAgo';
import { useOTSTranslation } from 'i18n/useOTSTranslation';
import { formatDateFromStr, formatShortDateStr } from 'util/formatDate';
import styles from './styles.module.scss';

interface ISnowItemProps {
  snow: number,
  date: string,
  height: number,
  hasSnowFlake?: boolean
  isMetricUnits?: boolean
}

export const SnowItemData = ({ snow, isMetricUnits } : ISnowItemProps) => (
  <td className={styles.cell}>
    <span className={cn(styles.snow, { [styles.metric]: isMetricUnits })}><SnowUnit values={snow} /></span>
  </td>
);

export const SnowItemTh = ({ date } :ISnowItemProps) => {
  const { t } = useOTSTranslation('common');

  return (
    <th scope="col" className={styles.cell}>
      <time dateTime={formatDateFromStr(date, 'yyyy-MM-dd')}>
        <span className={styles.date}>{formatShortDateStr(date)}</span>
        <span className={styles.day}>{formatAsTodYestTomWeekday(date, t)}</span>
      </time>
    </th>
  );
};

export const SnowItemChart = ({ height, hasSnowFlake }: ISnowItemProps) => (
  <td className={styles.cell}>
    <span className={styles.col}>
      <span className={styles.bar} style={{ height: `${height * 100}%` }} />
      {hasSnowFlake && <span className={styles.snowFlake}><SvgSnowFlake /></span>}
    </span>
  </td>
);
